export default "__VITE_ASSET__CUjgW2Wp__"